// "עכשיו" של הדפדפן לכל הדף — timer אחד לדקה (לא אחד לכל תור), מתחיל כשיש מנוי ונעצר כשאין (11: "לפני 3 דקות" חי, בלי רענון).
import { useSyncExternalStore } from 'react';

const subs = new Set<() => void>();
let now = Date.now();
let timer: ReturnType<typeof setInterval> | null = null;

export function subscribeNow(cb: () => void) {
  subs.add(cb);
  if (!timer) {
    now = Date.now();
    timer = setInterval(() => {
      now = Date.now();
      for (const s of subs) s();
    }, 60_000);
  }
  return () => {
    subs.delete(cb);
    if (!subs.size && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}

export const getNow = () => now;
/** מספר המנויים הפעילים — לבדיקות (timer אחד משותף). */
export const nowSubscribers = () => subs.size;
export const nowTimerRunning = () => timer != null;

/** Date.now() שמתעדכן כל דקה; כל הרכיבים בדף חולקים אותו timer. */
export function useMinuteNow(): number {
  return useSyncExternalStore(subscribeNow, getNow, getNow);
}
